import React from 'react';
import { Card, CardContent, CardHeader, CardTitle } from '../components/ui/card';
import { 
  HelpCircle, Book, Video, MessageCircle, Mail, 
  FileText, Zap, Car, Settings, Download, CreditCard 
} from 'lucide-react';
import { Link } from 'react-router-dom';

const HilfeCenterPage = () => {
  const helpCategories = [
    {
      title: 'Erste Schritte',
      icon: Zap,
      color: '#22C55E',
      links: [
        { label: 'Konto erstellen & einrichten', href: '/faq' },
        { label: 'Erste Diagnose starten', href: '/faq' },
        { label: 'Fahrzeug hinzufügen', href: '/faq' },
        { label: 'Plan auswählen', href: '/signup' }
      ]
    },
    {
      title: 'KI-Diagnose',
      icon: Car,
      color: '#7CD4FD',
      links: [
        { label: 'Wie funktioniert die Diagnose?', href: '/faq' },
        { label: 'Symptome richtig beschreiben', href: '/faq' },
        { label: 'PDF-Berichte verstehen', href: '/faq' },
        { label: 'Istwert-Beurteilung nutzen', href: '/faq' }
      ]
    },
    {
      title: 'OBD Live-Diagnose',
      icon: Download,
      color: '#F59E0B',
      links: [
        { label: 'OBD-Agent installieren', href: '/downloads' },
        { label: 'Dongle verbinden', href: '/faq' },
        { label: 'Live-Daten auslesen', href: '/faq' },
        { label: 'Fehlerbehebung Verbindung', href: '/faq' }
      ]
    },
    {
      title: 'Abonnement & Zahlung',
      icon: CreditCard,
      color: '#A78BFA',
      links: [
        { label: 'Plan ändern oder upgraden', href: '/subscription' },
        { label: 'Rechnung herunterladen', href: '/invoices' },
        { label: 'Zahlungsmethode ändern', href: '/settings' },
        { label: 'Abo kündigen', href: '/faq' }
      ]
    },
    {
      title: 'Konto & Einstellungen',
      icon: Settings,
      color: '#EC4899',
      links: [
        { label: 'Profil bearbeiten', href: '/settings' },
        { label: 'Passwort ändern', href: '/settings' },
        { label: 'Benachrichtigungen', href: '/settings' },
        { label: 'Daten exportieren', href: '/faq' }
      ]
    },
    {
      title: 'FAQ & Dokumentation',
      icon: Book,
      color: '#06B6D4',
      links: [
        { label: 'Häufige Fragen (FAQ)', href: '/faq' },
        { label: 'Datenschutz', href: '/datenschutz' },
        { label: 'AGB', href: '/agb' },
        { label: 'Impressum', href: '/impressum' }
      ]
    }
  ];

  return (
    <div className="min-h-screen p-8" style={{ backgroundColor: '#0B0F14' }}>
      <div className="max-w-6xl mx-auto">
        {/* Header */}
        <div className="mb-10 text-center">
          <div className="flex items-center justify-center gap-3 mb-4">
            <HelpCircle style={{ color: '#7CD4FD' }} size={40} />
            <h1 className="text-4xl font-bold" style={{ color: '#E6EDF3' }}>
              Hilfe Center
            </h1>
          </div>
          <p className="text-lg" style={{ color: '#94A3B8' }}>
            Finden Sie Antworten und lernen Sie CarCortex-AI optimal zu nutzen
          </p>
        </div>

        {/* Quick Actions */}
        <div className="grid grid-cols-1 md:grid-cols-3 gap-4 mb-10">
          <Link to="/faq" className="block">
            <Card 
              className="hover:border-[#7CD4FD] transition-colors cursor-pointer h-full"
              style={{ backgroundColor: '#0F141A', borderColor: '#1F2937' }}
            >
              <CardContent className="p-6 flex items-center gap-4">
                <div className="p-3 rounded-lg" style={{ backgroundColor: '#7CD4FD20' }}>
                  <FileText className="w-6 h-6" style={{ color: '#7CD4FD' }} />
                </div>
                <div>
                  <h3 className="font-semibold" style={{ color: '#E6EDF3' }}>FAQ durchsuchen</h3>
                  <p className="text-sm" style={{ color: '#94A3B8' }}>Häufige Fragen & Antworten</p>
                </div>
              </CardContent>
            </Card>
          </Link>

          <Link to="/kontakt" className="block">
            <Card 
              className="hover:border-[#22C55E] transition-colors cursor-pointer h-full"
              style={{ backgroundColor: '#0F141A', borderColor: '#1F2937' }}
            >
              <CardContent className="p-6 flex items-center gap-4">
                <div className="p-3 rounded-lg" style={{ backgroundColor: '#22C55E20' }}>
                  <MessageCircle className="w-6 h-6" style={{ color: '#22C55E' }} />
                </div>
                <div>
                  <h3 className="font-semibold" style={{ color: '#E6EDF3' }}>Support kontaktieren</h3>
                  <p className="text-sm" style={{ color: '#94A3B8' }}>Wir helfen Ihnen gerne</p>
                </div>
              </CardContent>
            </Card>
          </Link>

          <a href="mailto:support@carcortex-ai.com" className="block">
            <Card 
              className="hover:border-[#A78BFA] transition-colors cursor-pointer h-full"
              style={{ backgroundColor: '#0F141A', borderColor: '#1F2937' }}
            >
              <CardContent className="p-6 flex items-center gap-4">
                <div className="p-3 rounded-lg" style={{ backgroundColor: '#A78BFA20' }}>
                  <Mail className="w-6 h-6" style={{ color: '#A78BFA' }} />
                </div>
                <div>
                  <h3 className="font-semibold" style={{ color: '#E6EDF3' }}>E-Mail senden</h3>
                  <p className="text-sm" style={{ color: '#94A3B8' }}>support@carcortex-ai.com</p>
                </div>
              </CardContent>
            </Card>
          </a>
        </div>

        {/* Help Categories */}
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-6">
          {helpCategories.map((category, idx) => (
            <Card 
              key={idx}
              style={{ backgroundColor: '#0F141A', borderColor: '#1F2937' }}
            >
              <CardHeader className="pb-3">
                <div className="flex items-center gap-3">
                  <div 
                    className="p-2 rounded-lg" 
                    style={{ backgroundColor: `${category.color}20` }}
                  >
                    <category.icon className="w-5 h-5" style={{ color: category.color }} />
                  </div>
                  <CardTitle style={{ color: '#E6EDF3', fontSize: '1.1rem' }}>
                    {category.title}
                  </CardTitle>
                </div>
              </CardHeader>
              <CardContent>
                <ul className="space-y-2">
                  {category.links.map((link, linkIdx) => (
                    <li key={linkIdx}>
                      <Link 
                        to={link.href}
                        className="text-sm hover:underline transition-colors"
                        style={{ color: '#94A3B8' }}
                        onMouseEnter={(e) => e.target.style.color = category.color}
                        onMouseLeave={(e) => e.target.style.color = '#94A3B8'}
                      >
                        → {link.label}
                      </Link>
                    </li>
                  ))}
                </ul>
              </CardContent>
            </Card>
          ))}
        </div>

        {/* Video Tutorials Placeholder */}
        <Card 
          className="mt-10"
          style={{ backgroundColor: '#0F141A', borderColor: '#1F2937' }}
        >
          <CardContent className="p-8 text-center">
            <Video className="w-12 h-12 mx-auto mb-4" style={{ color: '#7CD4FD' }} />
            <h3 className="text-xl font-semibold mb-2" style={{ color: '#E6EDF3' }}>
              Video-Tutorials
            </h3>
            <p className="mb-4" style={{ color: '#94A3B8' }}>
              Schritt-für-Schritt Anleitungen für alle Features von CarCortex-AI
            </p>
            <p className="text-sm" style={{ color: '#6B7280' }}>
              Demnächst verfügbar
            </p>
          </CardContent>
        </Card>

        {/* Contact Info */}
        <div className="mt-10 text-center">
          <p style={{ color: '#94A3B8' }}>
            Nicht gefunden wonach Sie suchen?{' '}
            <Link to="/kontakt" style={{ color: '#7CD4FD' }} className="hover:underline">
              Kontaktieren Sie uns
            </Link>
          </p>
        </div>
      </div>
    </div>
  );
};

export default HilfeCenterPage;
